import { ThinBorderStyle } from './DesignSystem';
import { Palette } from './Palette';
import {
  EnableScreenPalette,
  ScreenPreview,
  useScreenPreview,
} from './ScreenPreview';

export function ScreenPalette() {
  const { state } = useScreenPreview();

  if (!EnableScreenPalette) {
    return <></>;
  }

  const screens = Object.values(state.screensByID);

  return (
    <Palette title="Screen" windowID="screens">
      <div>
        {screens.map((screen, i) => {
          const isLast = i + 1 === screens.length;
          return (
            <div
              key={screen.id}
              style={{
                marginBlockEnd: !isLast ? 4 : 0,
                paddingBlockEnd: !isLast ? 4 : 0,
                borderBottom: !isLast ? ThinBorderStyle.border : undefined,
              }}
            >
              <ScreenPreview screen={screen} />
            </div>
          );
        })}
      </div>
    </Palette>
  );
}
